import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialOrderLinesFinanceFilterData,
  InitialOrderLinesFinanceFilterDataVariables
} from "./types/InitialOrderLinesFinanceFilterData";
import {
  OrderLinesFinance,
  OrderLinesFinanceVariables
} from "./types/OrderLinesFinance";
import {
  OrderLinesFinanceDownload,
  OrderLinesFinanceDownloadVariables
} from "./types/OrderLinesFinanceDownload";

export const orderLinesFinanceListQuery = gql`
  ${pageInfoFragment}
  query OrderLinesFinance(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: OrderLinesFilterInput!
  ) {
    orderLinesFinance(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          sku_level_status
          order_date
          store_order_code
          product_name
          quantity
          price_paid
        }
      }
    }
  }
`;

export const useOrderLinesFinanceReportListQuery = makeBossQuery<
  OrderLinesFinance,
  OrderLinesFinanceVariables
>(orderLinesFinanceListQuery);

export const orderLinesFinanceDownloadQuery = gql`
  ${pageInfoFragment}
  query OrderLinesFinanceDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: OrderLinesFilterInput!
  ) {
    orderLinesFinance(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          order_status
          store_order_status
          sku_level_status
          order_date
          completed_at
          canceled_at
          order_code
          store_order_code
          shipping_method_name
          payment_method_type
          product_sku
          product_name
          variant_name
          quantity
          retail_price
          sales_discount_tenant
          sales_discount_sm
          sales_discount_total
          selling_price
          price_paid
          total_subsidy
          discrepancy
          price_amount
        }
      }
    }
  }
`;

export const useOrderLinesFinanceDownloadQuery = makeBossQuery<
  OrderLinesFinanceDownload,
  OrderLinesFinanceDownloadVariables
>(orderLinesFinanceDownloadQuery);

export const initialOrderLinesFinanceFilterDataQuery = gql`
  query InitialOrderLinesFinanceFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialOrderLinesFinanceFilterDataQuery = makeQuery<
  InitialOrderLinesFinanceFilterData,
  InitialOrderLinesFinanceFilterDataVariables
>(initialOrderLinesFinanceFilterDataQuery);
